// @flow
import WebComponent from '../src/webComponents/WebComponent';
import priorityNav from 'priority-nav';

export default class GreedyMenu extends WebComponent {
  didMount() {
    const {
      greedyMenuDropdownLabel,
      greedyMenuDropdownBreakpointLabel,
      greedyMenuBreakpoint,
    } = this.props;

    const greedyMenu = priorityNav.init({
      mainNavWrapper: '.greedy-menu__nav',
      mainNav: '.greedy-menu__list',
      navDropdownLabel: greedyMenuDropdownLabel,
      navDropdownBreakpointLabel: greedyMenuDropdownBreakpointLabel,
      breakPoint: greedyMenuBreakpoint,
      navDropdownClassName: 'greedy-menu__dropdown',
      navDropdownToggleClassName: 'greedy-menu__dropdown-toggle',
    });
  }
}




// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/GreedyMenu.js